export default {
      id: "map__car_type_k9-usage",
      viewBox: "0 0 36 33",
      url: __webpack_public_path__ + "img/icons.svg#map__car_type_k9",
      toString: function () {
        return this.url;
      }
    }